/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

const observer = new MutationObserver(() => {
  const dots = document.querySelector('.flickity-page-dots');
  if (!dots) return;
  if (dots.querySelector('.flickity-pause-btn')) {
    observer.disconnect();
    return;
  }

  const sliderEl = dots.closest('slider-component');
  if (!sliderEl?.flkty) return;

  const flkty = sliderEl.flkty;
  if (!flkty.options.autoPlay) return;

  observer.disconnect();

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    flkty.stopPlayer();
    return;
  }

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'flickity-pause-btn flickity-pause-btn--pause';
  btn.setAttribute('aria-label', 'Pause slideshow');
  btn.setAttribute('aria-pressed', 'false');
  btn.innerHTML = '⏸';
  dots.appendChild(btn);

  let paused = false;
  btn.addEventListener('click', () => {
    paused = !paused;
    if (paused) {
      flkty.stopPlayer();
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-label', 'Play slideshow');
      btn.innerHTML = '▶';
      btn.classList.remove('flickity-pause-btn--pause');
      btn.classList.add('flickity-pause-btn--play');
    } else {
      flkty.playPlayer();
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', 'Pause slideshow');
      btn.innerHTML = '⏸';
      btn.classList.remove('flickity-pause-btn--play');
      btn.classList.add('flickity-pause-btn--pause');
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });

(function() {
  // Add custom code below this line
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();




//quiz app

const observador = new MutationObserver(() => {
  const host = document.querySelector('#shadow-quiz');

  if (!host) return;

  observador.disconnect();

  // Ya lo encontraste.
  console.log(host);

  const shadow = host.shadowRoot;
    setTimeout(() => {
      const style = document.createElement('style');

      style.textContent = `

      .quiz {
      max-width: 990px;
      margin: auto;
      }
      .question-wrapper {
        min-height: 600px !important;
      }
        .question_button, .result-bottom-bar-button {
          border-radius: 0px !important;
          text-transform: uppercase !important;
          font-weight: 700 !important;

        }

        .question-block__input {
          border-radius: 0px !important;
        }

        .question-choice__label {
          border-radius: 0px !important;
        }

        .select-variants {
        border-radius: 0px !important;
        }   

        .navigation-bar__progress-bar-fill {
          background-color: black;
          transition: all 200ms;
        }

        .navigation-bar__container {
          align-items: flex-start;
          padding: 1rem 4rem;
        }
        .navigation-bar__button {
          background: transparent;
          color: black;
          transition: all 300ms;
          min-height: 32px;

        }

        .navigation-bar__button:hover {
          background: transparent!important;
          opacity: 0.6;
        }

        .result-bottom-bar__container {
          justify-content: center;
        }

        .results-slot_products_list {
          max-width: 100% !important;
        }

      `;

      shadow.appendChild(style);

    }, 500);


});

observador.observe(document.body, {
  childList: true,
  subtree: true
});




